import { render } from "./PackageBlockComponent.vue?vue&type=template&id=2f7f3080&ts=true"
import script from "./PackageBlockComponent?vue&type=script&lang=ts"
export * from "./PackageBlockComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__